import z from 'zod'

export const PLAYBOOK_WAITING_STATES = [
	'pending',
	'waiting',
	'running',
] as const

export const PLAYBOOK_SUCCESS_STATES = ['success'] as const
export const PLAYBOOK_ERROR_STATES = ['error'] as const
export const PLAYBOOK_CANCELLED_STATES = ['cancelled'] as const

export const PLAYBOOK_STATUS = z.enum([
	...PLAYBOOK_WAITING_STATES,
	...PLAYBOOK_SUCCESS_STATES,
	...PLAYBOOK_ERROR_STATES,
	...PLAYBOOK_CANCELLED_STATES,
])
